/** A tilted fan of champion legends for the landing page (runebound.gg's hero card fan, no ornament). */
import { CardImage, cn } from '@play/ui';
import { useCatalog } from '../lib/catalog';
import { cardFace, faceSources } from '../lib/cards';

const PICKS = 3;

/** Three legend cards, fanned. */
export function HeroFan({ className }: { className?: string }) {
  const catalog = useCatalog();
  if (!catalog) return <div className={cn('h-[260px]', className)} aria-hidden="true" />;
  const legends = catalog
    .cards()
    .filter((c) => c.type === 'Legend' && c.aliasOf === null && c.plainPrintingId !== null)
    .slice(0, 12)
    .filter((_, i) => i % 4 === 0)
    .slice(0, PICKS)
    .map((c) => cardFace(catalog, { cardId: c.id, printingId: c.plainPrintingId }));
  return (
    <div className={cn('relative h-[260px] w-[360px] max-w-full', className)} aria-hidden="true">
      {legends.map((face, i) => (
        <div
          key={face.cardId}
          className="absolute top-4 w-[150px] shadow-[0_24px_60px_rgba(0,0,0,.55)] rounded-[12px] transition-transform duration-300 hover:-translate-y-2"
          style={{
            left: 30 + i * 90,
            rotate: `${(i - 1) * 9}deg`,
            translate: `0 ${i === 1 ? -10 : 8}px`,
            zIndex: i === 1 ? 2 : 1,
          }}
        >
          <CardImage sources={faceSources(face, 372)} alt="" />
        </div>
      ))}
    </div>
  );
}
